var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"c-grid",class:{bord:_vm.bord}},[_vm._t("default",function(){return [_c('c-grid-item',{attrs:{"gridItems":_vm.gridItems}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }